// Re-authentication modal for the SPA.
// Opens when an API call returns 401 for a browser that had a confirmed prior
// session (dispatched as 'auth:expired' — see api.js's HAD_SESSION_KEY gate,
// C1249: a first-time visitor never sees this, they land straight on /login).
// The modal no longer runs its own Google popup flow — its one action sends
// the user to the full sign-in page, which offers every sign-in method.

let _overlay = null;

export function openReauthModal({ onComplete, onCancel } = {}) {
  if (_overlay) return; // already open

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.paddingRight = scrollbarWidth + 'px';
  document.documentElement.style.overflowY = 'hidden';

  _overlay = document.createElement('div');
  _overlay.className = 'reauth-modal-overlay';
  _overlay.setAttribute('role', 'dialog');
  _overlay.setAttribute('aria-modal', 'true');
  _overlay.setAttribute('aria-labelledby', 'reauth-modal-title');
  _overlay.innerHTML = `
    <div class="reauth-modal-backdrop"></div>
    <div class="reauth-modal-panel">
      <h2 class="reauth-modal-title" id="reauth-modal-title">Session expired</h2>
      <p class="reauth-modal-body">Your session has expired. Sign in again to continue — unsaved work won't be lost.</p>
      <div class="reauth-modal-actions">
        <button class="btn btn-ghost" id="reauth-cancel-btn">Cancel</button>
        <button class="btn btn-primary" id="reauth-signin-btn">Sign in</button>
      </div>
    </div>`;

  document.body.appendChild(_overlay);

  const signinBtn = _overlay.querySelector('#reauth-signin-btn');
  const cancelBtn = _overlay.querySelector('#reauth-cancel-btn');

  // Focus trap
  const focusable = [cancelBtn, signinBtn];
  _overlay.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { _doCancel(); return; }
    if (e.key === 'Tab') {
      e.preventDefault();
      const idx = focusable.indexOf(document.activeElement);
      const next = (idx + (e.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
      focusable[next].focus();
    }
  });
  requestAnimationFrame(() => signinBtn.focus());

  const _doCancel = () => {
    _cleanup();
    window.dispatchEvent(new CustomEvent('auth:cancelled'));
    if (onCancel) onCancel();
  };

  cancelBtn.addEventListener('click', _doCancel);

  // Sending the user to /login is itself a cancel of "stay on this page" —
  // whatever apiFetch call originally 401'd is not retried, the SPA just
  // navigates away. index.js's onCancel already does navigate('/login').
  signinBtn.addEventListener('click', () => {
    _cleanup();
    window.dispatchEvent(new CustomEvent('auth:cancelled'));
    if (onCancel) onCancel();
  });
}

function _cleanup() {
  if (_overlay) { _overlay.remove(); _overlay = null; }
  document.body.style.paddingRight = '';
  document.documentElement.style.overflowY = '';
}

export function closeReauthModal() {
  _cleanup();
}
